// users.js
import { defineStore } from 'pinia'
import axios from 'axios'
import defaultImg from '@/assets/icons_svg/User.svg';

export const useUsersStore = defineStore('users', {
    state: () => ({
        AllUsers: [],
        AllUsersAvailable: [],
        usersList: [],
        prefix: [
            {
                prefix_id: 1,
                prefixNameTh: 'นาย',
                prefixNameEn: 'Mr.',
            },
            {
                prefix_id: 2,
                prefixNameTh: 'นางสาว',
                prefixNameEn: 'Ms.',
            },
            {
                prefix_id: 3,
                prefixNameTh: 'นาง',
                prefixNameEn: 'Mrs.',
            },
        ],
        defaultImg: defaultImg
    }),
    actions: {
        async getAllUsers(filter) {
            try {
                const response = await axios.get('/users', { params: filter })
                if (response.status === 200) {
                    this.AllUsers = response.data.data
                }
                return response;
            } catch (error) {
                console.error('getAllusers error:', error)
                throw error
            }
        },
        async getAllUsersAvailable(filter) {
            try {
                const response = await axios.get('/users/available', { params: filter })
                if (response.status === 200) {
                    this.AllUsersAvailable = response.data.data
                }
                return response;
            } catch (error) {
                console.error('getAllusers error:', error)
                throw error
            }
        },
        async getUsers(filter) {
            try {
                const response = await axios.get('/users', { params: filter })
                if (response.status === 200) {
                    this.usersList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getUserById(id) {
            try {
                const response = await axios.get(`/user/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createUser(body) {
            try {
                const response = await axios.post('/user', body)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async approveUser(body) {
            try {
                const response = await axios.post('/user-approval', body)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async editUser(body) {
            try {
                const response = await axios.post(`/user/${body.id}`, body)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteUser(id) {
            try {
                const response = await axios.delete(`/user/${id}`)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
